export default "__VITE_ASSET__48a5ae9c__"